var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment"},[(_vm.preloadEnabled)?_c('add-payment-info',{attrs:{"acquisition-flow":true,"gifting-flow":true,"show-text":false,"heading":""},on:{"success":_vm.successAction}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }